// extracted by mini-css-extract-plugin
export default {"error":"ParishBookCategoryTags_error__QGBs5","emptyState":"ParishBookCategoryTags_emptyState__H7GyC"};